/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  font-size: 1rem;
  display: inline-block;
  margin-right: calc(14rem/14);
  margin-bottom: calc(8rem/14);
}
:host .flexbox {
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
          flex-direction: row;
  flex-wrap: nowrap;
  -webkit-box-pack: start;
          justify-content: flex-start;
  align-content: center;
  -webkit-box-align: center;
          align-items: center;
}
:host .flexbox svg {
  width: calc(20rem/14);
  height: calc(20rem/14);
  fill: #EA0823;
  fill: var(--davinci-color-error, #EA0823);
}
:host .flexbox .icon {
  -webkit-box-flex: 0;
          flex: 0 1 auto;
  fill: #697987;
  fill: var(--davinci-color-text-lighter, #697987);
}
:host .flexbox .label {
  -webkit-box-flex: 0;
          flex: 0 1 auto;
  margin-left: calc(8rem/14);
  font-size: 1rem;
  color: #323c43;
  color: var(--davinci-color-text, #323c43);
}

:host([status=true]) .flexbox svg {
  fill: #63b017;
  fill: var(--davinci-color-success, #63b017);
}

:host([disabled]) svg, :host([disabled]) .icon {
  fill: var(--davinci-color-outline-disabled,#D2D9DD) !important;
}
:host([disabled]) .label {
  color: #8999A4;
  color: var(--davinci-color-text-disabled, #8999A4);
}
:host([disabled]) .label slot ::slotted(*) {
  color: #8999A4;
  color: var(--davinci-color-text-disabled, #8999A4);
}`;
export { style };
//# sourceMappingURL=StatusIndicator.style.js.map